export default __webpack_public_path__ + "static/media/Pericles-Login.37644edf.png";